import { render, staticRenderFns } from "./GravityForm.vue?vue&type=template&id=74be9192&"
import script from "./GravityForm.vue?vue&type=script&lang=js&"
export * from "./GravityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports